type RestrictionsProps = {
  list: string[]
}

const Restrictions = ({ list }: RestrictionsProps) => {
  return (
    <div className="mb-6">
      <p className="typography-caption text-neutral-500">Restrictions</p>

      {list.map((restriction) => (
        <p className="typography-body-l" key={restriction}>
          -&nbsp;{restriction}
        </p>
      ))}
    </div>
  )
}

export default Restrictions
